import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type SkinnyLocationModel from 'garaje/models/skinny-location';

interface HrisDashboardModel {
  isReadOnly: boolean;
  locations: SkinnyLocationModel[];
}

export default class HrisDashboardController extends Controller {
  @tracked declare model: HrisDashboardModel;

  get isGlobal(): boolean {
    return false;
  }

  get isReadOnly(): boolean {
    return this.model?.isReadOnly ?? true;
  }

  get availableLocations(): SkinnyLocationModel[] {
    return this.model?.locations ?? [];
  }

  @action noop(): void {}
}
